import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useParams} from '@github-ui/react-router'
import {AnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepositoryProjectsPage as RepositoryProjectsPageContent} from '@github-ui/repository-projects'

import {issuesLayoutRoute} from './issues-layout-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function RepositoryProjectsPage() {
  const {owner = '', repo = ''} = useParams<{owner: string; repo: string}>()
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const renderSidebar = useRenderSidebar(owner, repo, layoutPayload)

  return (
    <AnalyticsWrapper category="Repository Projects Index" appName="issues">
      <RepositoryProjectsPageContent renderSidebar={renderSidebar} initialExpanded={layoutPayload?.sidebarExpanded} />
    </AnalyticsWrapper>
  )
}
